// extracted by mini-css-extract-plugin
export default {"TagIcon":"GiftTagAdvice_TagIcon__GJYR+","GiftTagAdviceOption":"GiftTagAdvice_GiftTagAdviceOption__b7z3I"};